import {
  getDashboardConfig,
  getGomsOnHoldFulfillments
} from '@store/actions/gomsFulfillmentActions';
import {
  GOMS_FULFILLMENT_SUB_STATUS,
  PENDING_FOR_HOURS_OPTIONS,
  TRM_STATUSES
} from '@views/GomsOrderDashboard/constant';
import { SORT_ORDER } from '@constants';


/**
 * Force Release Configuration
 * Defines the allowed statuses for showing the Force Release button
 */
export const forceReleaseConfig = {
  // Allowed fulfillment sub-statuses for force release
  allowedSubStatuses: [
    GOMS_FULFILLMENT_SUB_STATUS.ON_HOLD
  ],
  // Allowed TRM risk statuses for force release
  allowedTrmStatuses: [
    TRM_STATUSES.CHECK_FAILED
  ]
};

/**
 * Checks if force release action should be available for a fulfillment
 * @param {Object} fulfillment - The fulfillment data object
 * @returns {boolean} - True if force release should be shown
 */
export const canShowForceRelease = (fulfillment) => {
  if (!fulfillment) return false;

  const { subStatus, additionalDetails } = fulfillment;
  const trmStatus = additionalDetails?.riskDetails?.riskData?.status;

  const isAllowedSubStatus = forceReleaseConfig.allowedSubStatuses.includes(subStatus);
  const isAllowedTrmStatus = forceReleaseConfig.allowedTrmStatuses.includes(trmStatus);

  return isAllowedSubStatus && isAllowedTrmStatus;
};


export const gomsOrderDashboardConfigBuilder = () => {
  return {
    onHoldFulfillments : {
      searches : [
        {
          display: "Fulfillment Id",
          searchKey: "fulfillmentId",
          placeholder: "Search By Fulfillment ID",
          isDefault: true
        },
        {
          display: "Order ID",
          searchKey: "orderId",
          placeholder: "Search by Order ID",
          isDefault: false
        }
      ],
      filters: [
        {
          title: "Fulfillment Sub Statuses",
          key: "subStatuses",
          filters: Object.keys(GOMS_FULFILLMENT_SUB_STATUS)
        }
      ],
      sorting: {
        defaultSortKey: "created_at",
        defaultSortValue: "DESC",
        options: [
          {
            key: "created_at",
            display: "Created Date",
            values: Object.values(SORT_ORDER)
          }
        ]
      }
    }
  }
}

export const getPendingForHoursOptions = () =>
  PENDING_FOR_HOURS_OPTIONS.map((hour) => ({
    value: String(hour),
    label: `${hour} ${hour === 1 ? 'hour' : 'hours'}`
  }));

/**
 * General Config for Goms Dashboard
 */
export const generalConfig = {
  actions: {
    getDashboardConfig:() => getDashboardConfig()
  }
}


/**
 * Goms On Hold Fulfillment Configuration
 */
export const gomsOnHoldConfig = {
  id: 'gomsOnHoldConfig',
  actions: {
    getGomsOnHoldFulfillments: ({ payload, onSuccess, onComplete }) => getGomsOnHoldFulfillments({payload, onSuccess, onComplete}),
  }
};